export default "__VITE_ASSET__KG3SDF75__"